import { useEffect, useState } from 'react';
import { AvatarThumb } from '../components/AvatarThumb.js';
import { useMembersStore, photoObjectUrl } from './membersStore.js';

/**
 * Portrait d'une personne : sa photo de profil, sinon le visage de son
 * personnage, sinon l'initiale de son prénom (invités, comptes sans avatar).
 */
export function PersonAvatar({ userId, name, size = 32, highlight = false }: {
  userId: string;
  name: string;
  size?: number;
  /** Fond accentué pour l'initiale (soi-même). */
  highlight?: boolean;
}) {
  const member = useMembersStore((s) => s.members.get(userId));
  const [photo, setPhoto] = useState<string | null>(null);

  useEffect(() => {
    setPhoto(null);
    if (!member?.photoVersion) return;
    let alive = true;
    void photoObjectUrl(userId, member.photoVersion).then((url) => { if (alive) setPhoto(url); });
    return () => { alive = false; };
  }, [userId, member?.photoVersion]);

  const frame: React.CSSProperties = {
    flexShrink: 0, width: size, height: size, borderRadius: '50%', overflow: 'hidden',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  };
  if (photo) {
    return <img src={photo} alt="" aria-hidden="true" width={size} height={size} style={{ ...frame, objectFit: 'cover' }} />;
  }
  if (member?.sheet) {
    return (
      <span aria-hidden="true" style={{ ...frame, background: 'var(--color-bg-overlay)' }}>
        <AvatarThumb appearance={{ v: 2, sheet: member.sheet }} size={size} bare />
      </span>
    );
  }
  return (
    <span aria-hidden="true" style={{
      ...frame,
      background: highlight ? 'var(--color-primary)' : 'var(--color-bg-overlay)',
      color: highlight ? 'var(--color-on-primary)' : 'var(--color-text-primary)',
      font: `800 ${Math.round(size * 0.42)}px/1 var(--font-display)`,
    }}>
      {(name[0] ?? '?').toUpperCase()}
    </span>
  );
}
